export default __webpack_public_path__ + "static/media/TALKING_BADGES_YOU_love.2b4f7f05.png";